import { useSearchParams } from 'react-router-dom';

export const useGetParam = (name: string) => {
  const [search] = useSearchParams();
  return search.get(name);
};
